// import React, { useState } from 'react';
// import Avatar from '@mui/material/Avatar';
// import Button from '@mui/material/Button';
// import CssBaseline from '@mui/material/CssBaseline';
// import TextField from '@mui/material/TextField';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import Link from '@mui/material/Link';
// import Grid from '@mui/material/Grid';
// import Box from '@mui/material/Box';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import Typography from '@mui/material/Typography';
// import Container from '@mui/material/Container';
// import { Link as MUILink, Paper } from "@mui/material";


// export default function SignupForm() {
//     const handleSubmit = (event) => {
//         event.preventDefault();
//         const data = new FormData(event.currentTarget);
//         console.log({
//             email: data.get('email'),
//             password: data.get('password'),
//         });
//     };
//     const [termsStatus, setTermsStatus] = useState(false);
//     const [isAcceptTerms, setIsAcceptTerms] = useState(true);
//     return (
//         <Container>
//             <Grid sx={{ pb: "10px", borderRadius: "8px" }} item xs={12} sm={8} md={12} component={Paper} elevation={6} square>
//                 <Box
//                     sx={{
//                         my: 8,
//                         mx: 4,
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                     }}
//                 >
//                     <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
//                         <LockOutlinedIcon />
//                     </Avatar>
//                     <Typography component="h1" variant="h5">
//                         Sign up
//                     </Typography>
//                     <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
//                         <Grid container spacing={2}>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     autoComplete="given-name"
//                                     name="firstName"
//                                     required
//                                     fullWidth
//                                     id="firstName"
//                                     label="First Name"
//                                     autoFocus
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     required
//                                     fullWidth
//                                     id="lastName"
//                                     label="Last Name"
//                                     name="lastName"
//                                     autoComplete="family-name"
//                                 />
//                             </Grid>
//                             <Grid item xs={12}>
//                                 <TextField
//                                     required
//                                     fullWidth
//                                     id="email"
//                                     label="Email Address"
//                                     name="email"
//                                     autoComplete="email"
//                                 />
//                             </Grid>
//                             <Grid item xs={12}>
//                                 <TextField
//                                     required
//                                     fullWidth
//                                     name="password"
//                                     label="Password"
//                                     type="password"
//                                     id="password"
//                                     autoComplete="new-password"
//                                 />
//                             </Grid>
//                             <Grid item xs={12}>
//                                 <FormControlLabel
//                                     control={<Checkbox value="allowExtraEmails"
//                                         onChange={(e) => {
//                                             setTermsStatus(!termsStatus);
//                                             if (e.target.checked) {
//                                                 setIsAcceptTerms(true);
//                                             } else {
//                                                 setIsAcceptTerms(false);
//                                             }
//                                         }}
//                                         color="primary" />}
//                                     label={
//                                         <Typography
//                                             sx={{
//                                                 fontSize: "10px",
//                                                 color: !isAcceptTerms ? "danger.main" : "primary.black",
//                                             }}
//                                         >
//                                             I agree to{" "}
//                                             <MUILink underline="hover" sx={{ cursor: "pointer" }}>
//                                                 <Link
//                                                     style={{ textDecoration: "none", color: "inherit" }}
//                                                 // to={'/termsandservices'}
//                                                 >
//                                                     {" "}
//                                                     Terms of Services
//                                                 </Link>
//                                             </MUILink>{" "}
//                                             and{" "}
//                                             <MUILink underline="hover" sx={{ cursor: "pointer" }}>
//                                                 <Link
//                                                     style={{ textDecoration: "none", color: "inherit" }}
//                                                 // to={'/privacypolicy'}
//                                                 >
//                                                     {" "}
//                                                     Privacy Policy
//                                                 </Link>
//                                             </MUILink>
//                                         </Typography>
//                                     }
//                                 />
//                             </Grid>
//                         </Grid>
//                         <Button
//                             type="submit"
//                             fullWidth
//                             variant="contained"
//                             sx={{ mt: 3, mb: 2 }}
//                         >
//                             Sign Up
//                         </Button>
//                         <Grid container justifyContent="flex-end">
//                             <Grid item>
//                                 <Link href="#" variant="body2">
//                                     Already have an account? Sign in
//                                 </Link>
//                             </Grid>
//                         </Grid>
//                     </Box>
//                 </Box>
//             </Grid>
//         </Container>
//     );
// }
import React from 'react';
import { Grid, Box, TextField, Button, Checkbox, FormControlLabel, Typography, Paper } from '@mui/material';

const SignUpForm = () => {
    return (
        <Grid container component={Paper} elevation={6} square>
            <div className="form-container sign-in-container">
                <form action="#">
                    <h1>Sign in</h1>
                    <div className="social-container">
                        <a href="#" className="social"><i className="fab fa-facebook-f"></i></a>
                        <a href="#" className="social"><i className="fab fa-google-plus-g"></i></a>
                        <a href="#" className="social"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                    <span>or use your account</span>
                    <input type="email" placeholder="Email" />
                    <input type="password" placeholder="Password" />
                    <a href="#">Forgot your password?</a>
                    <button>Sign In</button>
                </form>
            </div>
        </Grid>
    );
};

export default SignUpForm;
